import React from 'react';
import styled from '@emotion/styled';

export interface TableProps<T extends { id: number | string }> {
  headers: string[];
  data?: T[];
  onClick: (id: T['id']) => void;
}

export const TableWrapper = styled.div`
  width: 100%;
  margin: 0 auto;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
`;

export const TableHead = styled.thead`
  background-color: #fff;
`;

export const TableRow = styled.tr<{ onClick?: () => void }>`
  cursor: ${(props) => (props.onClick ? 'pointer' : 'auto')};
  ${(props) => props.onClick && `
    &:hover {
      background-color: rgba(224, 224, 224, 0.5);
    }
  `}
  
  border-bottom: 1px solid #e5e8ec;
`;
export const TableHeader = styled.th`
  padding: 10px;
  border: none;
  text-align: center;
  background-color: #fff;
  font-weight: bold;
  font-size: 0.875rem;
  /* 한글이 글자 단위로 쪼개지지 않게 단어 단위 줄바꿈 */
  word-break: keep-all;
  white-space: nowrap;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;

  @media (max-width: 768px) {
    padding: 8px 4px;
    font-size: 0.8125rem;
  }
`;

export const TableCell = styled.td<{textalign?:string}>`
  padding: 10px;
  border: none;
  text-align: ${(props) => props.textalign || "left"};
  /* 한글 단어 단위 줄바꿈 (업무/진료실/데스크/정규직 등이 글자 단위로 깨지지 않게) */
  word-break: keep-all;

  @media (max-width: 768px) {
    padding: 8px 4px;
    font-size: 0.8125rem;
  }
`;

const TableComponent = <T extends { id: number | string }>({ headers, data, onClick }: TableProps<T>) => {
  return (
    <TableWrapper>
      <Table>
        <TableHead>
          <tr>
            {headers.map((header, index) => (
              <TableHeader key={index}>{header}</TableHeader>
            ))}
          </tr>
        </TableHead>
        <tbody>
          {data?.map((row) => {
            const r = row as any;
            const city = r.clinic?.city ?? '';
            const district = r.clinic?.district ?? '';
            const location = [city, district].filter(Boolean).join(' ') || '-';
            return (
              <TableRow key={row.id} onClick={() => onClick(row.id as number)}>
                <TableCell>{r.clinic?.name ?? '-'}</TableCell>
                <TableCell>{r.title ?? '-'}</TableCell>
                <TableCell>{r.jobTasks?.[0] ?? '-'}</TableCell>
                <TableCell>{location}</TableCell>
                <TableCell>{r.recruitmentTypes?.[0] ?? '-'}</TableCell>
              </TableRow>
            );
          })}
        </tbody>
      </Table>
    </TableWrapper>
  );
};

export default TableComponent;
